import {MenuOption, PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const";
import {TaskAction} from "../@const";
import Task from "../../../../model2/task/task";
import taskView_getTimerOptions from "../../../../../item-view/task/components/timer/get-timer-options";


export type Props = {
    task                : Task

    hiddenActions?      : TaskAction[],
    disabledActions?    : string[]

    hidePopover?        : func
}

export function taskMore_initTimeTracking(props: Props, menuOptions: MenuOption[]) {

    const onClickPro = () => {
        gd.modals.other.upgradeToPro(gd.companyId)
    }

    if (props.hiddenActions?.includes(TaskAction.TIME_TRACKING)) return

    if (!gd.company.license.isPro) {
        menuOptions.push({
            type            : PopoverMenuItemType.ITEM,
            icon            : 'i5-hours',
            label           : 'Time tracking',
            isPro           : true,
            onClickUpgrade  : onClickPro,
        })
    } else {
        menuOptions.push({
            type        : PopoverMenuItemType.SUBMENU,
            icon        : 'i5-hours',
            label       : 'Time tracking',
            options     : taskView_getTimerOptions(props.task, props.hidePopover!),
            disabled    : !props.task.acl.canAddTimeTracking,
        })
    }
}
